import React from "react";
import { Tag } from "primereact/tag";
import type { ThgAnnualSummary } from "../../../types/thgAnnualSummary";
import { formatBerlin, formatCount } from "../utils/thgFormat";

interface SummaryHeaderProps {
  summary: ThgAnnualSummary;
  /** Export and recompute, rendered on the right. */
  actions?: React.ReactNode;
}

/**
 * What the figures below were produced under. Status comes first because it decides whether this list
 * may be paid from at all; rate and computed-at are always visible so a reader can match the screen to a
 * file exported earlier.
 */
const SummaryHeader: React.FC<SummaryHeaderProps> = ({ summary, actions = null }) => {
  const isFinal = summary.status === "FINAL";
  return (
    <div className="flex flex-column md:flex-row md:align-items-start md:justify-content-between gap-3 mb-3">
      <div className="flex flex-column gap-2">
        <div className="flex align-items-center gap-2">
          <span className="text-xl font-semibold">THG payouts {summary.year}</span>
          <Tag
            value={isFinal ? "Final" : "Provisional"}
            severity={isFinal ? "info" : "warning"}
            data-testid="thg-status"
          />
        </div>
        <div className="flex flex-wrap gap-3 text-color-secondary">
          <span>
            Rate: <span className="font-semibold text-color">{summary.rateEurPerMwh} €/MWh</span> of energy
            excluding free charging
          </span>
          <span>
            Computed {formatBerlin(summary.computedAt)} (Berlin time)
          </span>
          <span>Based on {formatCount(summary.sourceSessionCount)} sessions</span>
        </div>
      </div>
      {actions && <div className="flex gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
};

export default SummaryHeader;
